import { Application, FlipIntent, ScopeSlot, NOOP_VOID } from 'wdc-cube'
import { Places, AttrIds, ParamIds } from '../Constants'

export class MainKeys {
    protected _intent: FlipIntent
    protected _app: Application

    public allow: boolean

    constructor(app: Application, intent?: FlipIntent) {
        this.allow = true
        this._app = app
        this._intent = intent ? intent : app.newFlipIntent(this.place)
    }

    public get place() {
        return Places.main
    }

    public get targetPlace() {
        return this._intent.place
    }

    public get last() {
        return !this.allow || this.targetPlace === this.place
    }

    public flip(): Promise<void> {
        return this._app.flipToIntent(this._intent)
    }

    // :: Parameters

    public get resetPassword() {
        return this._intent.getParameterAsBoolean(ParamIds.resetPassword) ?? false
    }

    public set resetPassword(value: boolean) {
        if (value) {
            this._intent.setParameter(ParamIds.resetPassword, value)
        } else {
            this._intent.setParameter(ParamIds.resetPassword, null)
        }
    }

    // :: Compliance

    public get compliance() {
        return this._intent.getParameterAsBoolean(ParamIds.compliance) ?? false
    }

    public set compliance(value: boolean) {
        if (value) {
            this._intent.setParameter(ParamIds.compliance, value)
        } else {
            this._intent.setParameter(ParamIds.compliance, null)
        }
    }

    // :: parentSlot

    public get parentSlot() {
        return this._intent.getScopeSlot(AttrIds.parentSlot) ?? NOOP_VOID
    }

    public set parentSlot(value: ScopeSlot) {
        this._intent.setScopeSlot(AttrIds.parentSlot, value)
    }

    // :: parentSlot

    public get dialogSlot() {
        return this._intent.getScopeSlot(AttrIds.dialogSlot) ?? NOOP_VOID
    }

    public set dialogSlot(value: ScopeSlot) {
        this._intent.setScopeSlot(AttrIds.dialogSlot, value)
    }
}
